import { FormattedMessage } from 'react-intl'

import { Typography } from '@gto/ui/typography'

import type { RedemptionOption } from '@/api/gen'

import { GtoSubscriptionPlanCard } from './gto-subscription-plan-card'

export const GtoSubscriptionPlansSection = ({ plans }: { plans: RedemptionOption[] }) => {
  return plans.length > 0 ? (
    <div className="flex gap-8">
      {plans.map((plan) => (
        <GtoSubscriptionPlanCard
          key={plan.id}
          {...plan}
        />
      ))}
    </div>
  ) : (
    <NoPlansPlaceholder />
  )
}

const NoPlansPlaceholder = () => {
  return (
    <div className="py-8 text-center">
      <Typography
        color="text.secondary"
        variant="body1"
      >
        <FormattedMessage id="edge.plansSection.noPlans" />
      </Typography>
    </div>
  )
}
